import React, { useState, useEffect } from "react";
import { Container, Typography, Card, CardContent, List, ListItem, ListItemText, CircularProgress } from "@mui/material";
import { getUserProfile, getUserTeams, getLinkedAccounts } from "../api/api"; // API Calls

const Home = () => {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [teams, setTeams] = useState([]);
  const [linkedAccounts, setLinkedAccounts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userProfile = await getUserProfile();
        const userTeams = await getUserTeams();
        const accounts = await getLinkedAccounts();

        setUser(userProfile);
        setTeams(userTeams);
        setLinkedAccounts(accounts);
      } catch (error) {
        console.error("Error loading data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <Container sx={{ textAlign: "center", mt: 4 }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container sx={{ mt: 4 }}>
      {/* User Profile */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h5">Profile</Typography>
          <Typography variant="body1"><strong>Name:</strong> {user.name}</Typography>
          <Typography variant="body1"><strong>Email:</strong> {user.email}</Typography>
        </CardContent>
      </Card>

      {/* Linked Accounts */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h5">Connected Accounts</Typography>
          {linkedAccounts.length > 0 ? (
            <List>
              {linkedAccounts.map((account, index) => (
                <ListItem key={index}>
                  <ListItemText primary={account.type} secondary={account.email} />
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body2">No linked accounts.</Typography>
          )}
        </CardContent>
      </Card>


      {/* Teams */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h5">Your Teams</Typography>
          {teams.length > 0 ? (
            <List>
              {teams.map((team) => (
                <ListItem key={team.id}>
                  <ListItemText primary={team.name} secondary={`Role: ${team.role}`} />
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body2">You are not part of any teams.</Typography>
          )}
        </CardContent>
      </Card>

    </Container>
  );
};

export default Home;
